import ActivateAccount from '../components/views/register/ActivateAccount.vue'


const routes = [{
    path: 'activate',
    component: ActivateAccount,
    name: 'ActivateAccount',
    meta: {

        title: 'Activate Account',

    }
}]


export default routes


// WEBPACK FOOTER //
// ./src/routes/register.route.js